import React from 'react';

const Views = ({ items, active, setActive }) => (
    <div className="rs-views">
        {items.map(({ id, label, count }) => (
            <button
                key={id}
                type="button"
                className={`rs-view-tab ${active === id ? 'on' : ''}`}
                onClick={() => setActive(id)}
            >
                {label}
                <span className="ct">{count}</span>
            </button>
        ))}
        <button type="button" className="rs-view-tab add">+ Save view</button>
    </div>
);

export default Views;
